import { useState } from 'react';

import type { CopiedOutline } from '../types';

/**
 * Owns the copied-selection state for one grid instance (Sheets semantics:
 * other tabs can paste via the clipboard, but only the source instance draws
 * the marching-ants outline). Pass `outline` to the grid's `copiedOutline`
 * prop — resolution against the current row/column order happens inside the
 * grid.
 *
 * The clipboard is the source of truth for the payload; the outline is just a
 * hint. Paste handlers may reconcile via `copyId`: if the pasted payload
 * carries a different one, the OS clipboard was overwritten since — clear the
 * outline. Handlers that clear the outline on every paste don't set `copyId`.
 */
export function useCopiedOutline(): {
  outline: CopiedOutline | null;
  copyId: string | null;
  setOutline: (outline: CopiedOutline | null) => void;
} {
  const [outline, setOutline] = useState<CopiedOutline | null>(null);
  return { outline, copyId: outline?.copyId ?? null, setOutline };
}
